module.exports = __webpack_public_path__ + "img/butongguo.67b8258f.svg";